import { RG_TYPE } from "@project-rouge/rg-core";
function getFireCoreCount(sequence) {
	let count = 0;
	for (let i = 0; i < sequence.length; i++) {
		const unit = sequence[i].unit;
		if (unit.type === RG_TYPE.Core && unit.data.hasFireLift) count++;
	}
	return count;
}
export { getFireCoreCount };

//# sourceMappingURL=index136.js.map